import { useParams } from "@/router";
import { PersonGovernanceTable } from "./_PersonGovernanceTable";

export default function PersonGovernanceRolesPage() {
  const { pgaId } = useParams("/people/:pgaId/career/governance-roles");

  return <PersonGovernanceTable pgaId={pgaId} />;
}
